import type { SVGProps } from 'react';

const WarningSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      d="M14.5025 7.88126C15.1758 6.70624 16.8242 6.70625 17.4975 7.88126L25.7554 22.2936C26.4406 23.4894 25.6048 25 24.2579 25H7.74206C6.39524 25 5.55939 23.4894 6.24456 22.2936L14.5025 7.88126Z"
      fill="#E6A600"
    />
    <rect x="15" y="13" width="2" height="7" rx="1" fill="white" />
    <rect x="15" y="21" width="2" height="2" rx="1" fill="white" />
  </svg>
);
export default WarningSvgIcon;
